// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1RhJE","empty":"ModalGraph_empty__3DaY8"};